import React from "react";
import styles from "./styles.module.scss";
import { Box as MantineBox } from "@mantine/core";

const StaticBanner = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <MantineBox className={`${styles.staticBanner} ${className || ""}`}>
      <MantineBox>{children}</MantineBox>
    </MantineBox>
  );
};

export default StaticBanner;
